/**
 * Main application entry point
 *
 * jQuery is available globally via OctoberCMS (@jquery in partials).
 * Do NOT import it here — use window.$ or window.jQuery.
 *
 * Component pattern:
 *   1. Create a module in components/ that exports an init function
 *   2. Import and call it below
 *   3. For heavy components, use dynamic import() for lazy loading
 */

// --- Components (eager) ---
import { initForms } from './components/form.js';
import { initValidation } from './components/validation.js';
import { initOffCanvas } from './components/off-canvas.js';
import { initFaq } from './components/faq.js';
import { initAccordion } from './components/accordion.js';
import { initScrollAnimations } from './components/scroll-animations.js';
import { initHeaderScroll } from './components/header-scroll.js';

// --- Init ---
document.addEventListener('DOMContentLoaded', () => {
  initForms();
  initValidation();
  initOffCanvas();
  initFaq();
  initAccordion();
  initScrollAnimations();
  initHeaderScroll();

  // --- Components (lazy — loaded only when needed) ---
  if (document.querySelector('[data-quote-carousel]')) {
    import('./components/quote-carousel.js').then(m => m.initQuoteCarousel());
  }
  if (document.querySelector('[data-image-compare]')) {
    import('./components/image-compare.js').then(m => m.initImageCompare());
  }
});

// --- Consent cookie ---
document.querySelectorAll('.ConsentCookieShow').forEach(el => {
  el.setAttribute('data-cc', 'show-preferencesModal');
});
